module.exports = __webpack_public_path__ + "static/L2_content_text_equivalents_2_eg-31dd5b4d1b7fe56cee992dbc1af825f8.png";